export enum DataHooks {
  BackButton = 'calendar-back-button',
}
